import React from 'react';
import CurrentUserDetail from '../../model/currentuser/CurrentUserDetail';
import LegislationProcessInfo from '../../model/currentuser/LegislationProcessInfo';
import { ClientStatus } from '../../model/ClientStatus';

export interface UserContextContent {
  pouzivatel: CurrentUserDetail;
  legislationProcess: LegislationProcessInfo;
  status: ClientStatus | undefined,
  fetchProfile: (type: string, year: number, index: number) => void;
}

export default React.createContext<UserContextContent>({
  pouzivatel: null, legislationProcess: null, status: undefined, fetchProfile: null,
});
